import { get } from '../utils/axios'

export const getSignaturesAPI = async (param) => {
  return await get('signatures', param)
}
